<h2 mat-dialog-title> Login</h2>
<form class="login-form" mat-dialog-content [formGroup]="form">
  <div>
    <mat-form-field class="example-full-width">
      <mat-label>Email</mat-label>
      <input  type="email" name="username" 
              matInput
              formControlName="username"
              placeholder="Ex. pat@example.com" 
              #username>
    </mat-form-field>
  </div>
  <div><mat-form-field appearance="fill">
      <mat-label>Enter your password</mat-label>
      <input  [type]="hidepw ? 'password' : 'text'"
              matInput
              formControlName="password"  
              #password>
      <button mat-icon-button matSuffix 
              (click)="hidepw = !hidepw" 
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hidepw">
        <mat-icon>{{hidepw ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
  </div>
</form>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close (click)="doLogin()" [disabled]="!form.valid">Login</button>
</div>

